module.exports = __webpack_public_path__ + "9b9e0972993dde39b2c175b95a200717.fbx";